module.exports = __webpack_public_path__ + "static/whereNextBannerImage.ebc21916.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/whereNextBannerImage.jpg
// module id = 54
// module chunks = 35783957827783 174759553322802 227638899823042